import { Plugin } from 'prosemirror-state';

import { BaseExtension, colorHighlighterKey, EditorOptions } from '@lyearn/lygo-core';

import { findColors } from './utils';

// this plugin is used to add a hint of hex color written in the editor
// for example type #ff0000 and it will be highlighted with a red background
export default class ColorHighlighter extends BaseExtension {
  get name(): string {
    return 'color_highlighter';
  }

  plugins(_editorOptions: EditorOptions) {
    return [
      new Plugin({
        key: colorHighlighterKey,
        state: {
          init(_, { doc }) {
            return findColors(doc);
          },
          apply(transaction, oldState) {
            return transaction.docChanged ? findColors(transaction.doc) : oldState;
          },
        },
        props: {
          decorations: (state) => {
            return findColors(state.doc);
          },
        },
      }),
    ];
  }
}
